import { defineMessages } from 'react-intl'

const messages = defineMessages({
  back: {
    id: 'modules.Registration.back',
    defaultMessage: 'Back',
  },
  next: {
    id: 'modules.Registration.next',
    defaultMessage: 'Next',
  },
  title: {
    id: 'modules.Registration.title',
    defaultMessage: 'Registration',
  },
  registerError: {
    id: 'modules.Registration.registerError',
    defaultMessage: 'Could not register, please try again later.',
  },
})

export const labelMessages = defineMessages({
  administratorEmail: {
    id: 'modules.Registration.AdministratorStep.emailLabel',
    defaultMessage: 'Email',
  },
  administratorPassword: {
    id: 'modules.Registration.AdministratorStep.passwordLabel',
    defaultMessage: 'Set a password',
  },
  administratorName: {
    id: 'components.fields.labels.AdministratorName',
    defaultMessage: 'Full name',
  },
  companyName: {
    id: 'modules.Registration.CompanyStep.companyLabel',
    defaultMessage: 'Company name',
  },
  companyOrgNr: {
    id: 'modules.Registration.CompanyStep.companyOrgNrLabel',
    defaultMessage: 'Organization number',
  },
  siretNr: {
    id: 'modules.Registration.CompanyStep.siretNr',
    defaultMessage: 'SIRET number',
  },
  receiptEmail: {
    id: 'modules.Registration.EmailStep.label',
    defaultMessage: 'Contact email',
  },
  address: {
    id: 'modules.Registration.OfficeStep.addressLabel',
    defaultMessage: 'Street address',
  },
  zipCode: {
    id: 'modules.Registration.OfficeStep.zipLabel',
    defaultMessage: 'Zip code',
  },
  city: {
    id: 'modules.Registration.OfficeStep.cityLabel',
    defaultMessage: 'City',
  },
})

export default messages
